import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const ToggleSwitch = ({ label = '', name = '', checked = false, onChange }) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleToggle = e => {
    setIsChecked(e.target.checked);
    onChange && onChange(e);
  };

  return (
    <div className={styles.toggleSwitchWrapper}>
      {label && <span className={styles.labelText}>{label}</span>}
      <label htmlFor={name} className={`${styles.toggleSwitch}`}>
        <input
          id={name}
          name={name}
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
        <span className={`${styles.slider}`}></span>
      </label>
    </div>
  );
};

ToggleSwitch.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
};

ToggleSwitch.defaultProps = {
  name: '',
  checked: false,
  onChange: null,
  label: '',
};

export default ToggleSwitch;
